jQuery(document).ready(function ($) {
  //############################################//
  //###*****   Component - Side Navigation
  //###*****   Use with styles /styles/components/side-nav.scss
  //############################################//

  const mq = window.matchMedia('(max-width: 991px)');

  if (mq.matches) {
    $('.js-sidebar--toggle').on('click', function () {
      if ($(this).hasClass('is-open')) {
        $(this).next('.c-sidebar__wrapper').slideUp(200);
        $(this).removeClass('is-open');
        $(this).next('.c-sidebar__wrapper').removeClass('is-active');
      } else {
        $(this).next('.c-sidebar__wrapper').slideDown(200);
        $(this).addClass('is-open');
        $(this).next('.c-sidebar__wrapper').addClass('is-active');
      }
    });
  }
});
